import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { INFLUENCER_BASE } from '../constants';

const LOGIN_PATH = `${INFLUENCER_BASE}/login`;

const InfluencerProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const userData = localStorage.getItem('userData');
  const user = useSelector((state) => state.user.data);

  if (!token || !userData || !user) {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${LOGIN_PATH}?redirectTo=${redirectTo}`} replace />;
  }

  return children;
};

export default InfluencerProtectedRoute; 